<template>
  <div
    v-if="product"
    class="p2-container paywall"
  >
    <video
      autoplay
      muted
      loop
      playsinline
      class="video-background"
    >
      <source
        :src="video"
        type="video/mp4"
      >
    </video>
    <div class="overlay" />

    <div class="inner-container">
      <button
        class="close-button"
        @click="handleClose"
      >×</button>

      <div class="header-text">
        <div v-if="showTimer" class="timer">
          {{ displayTime }}
        </div>
        <h1 class="title">
          {{ $t('paywall2.title') }}
        </h1>
      </div>

      <div class="diamond-container">
        <h2 class="diamond-title">
          <diamond-icon />
          <span
            class="product-title"
            style="margin-left: 8px"
          >
            {{ product.credits }} {{ $t('Diamonds') }}
          </span>
        </h2>
        <p class="promo-text">
          {{ $t('paywall2.slogan', { rate: discountRate }) }}
        </p>

        <div class="paywall-footer">
          <div class="savings-text">
            {{ $t('Discount {rate}', { rate: discountRate }) }}!
          </div>

          <div class="price-box">
            <div class="diamond-package">
              <large-diamond-icon />
              <span class="diamond-amount product-title">
                {{ product.credits }} {{ $t('Diamonds') }}
              </span>
            </div>
            <div class="price-display">
              <div
                v-if="showOriginalPrice"
                class="original-price"
                id="original-price-container"
              >
                <span v-if="userCountry !== 'TR'" class="original-price">
                  ${{ originalPrice }}
                </span>
                <span v-else class="original-price">
                  &#8378;{{ originalPrice }}
                </span>
              </div>
              <div v-if="userCountry !== 'TR'" class="discounted-price">
                ${{ product.global_amount }}
              </div>
              <div v-else class="discounted-price">
                &#8378;{{ product.amount }}
              </div>
            </div>
          </div>

          <div style="padding: 16px; background-color: #000;">
            <router-link :to="{name: 'buy', params: { productId: product.product_id, purchaseSource: `web_${name}` }}">
              <button
                class="buy-button"
                @click="handleClose"
              >
                {{ $t('Buy Now') }}
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberFormat, endsWithN } from '@/helpers/helpers'

// SVG Icon Components
const DiamondIcon = {
  render(h) {
    return h('svg', {
      attrs: {
        width: '39',
        height: '31',
        viewBox: '0 0 39 31',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
      },
    }, [
      h('path', {
        attrs: {
          d: 'M0 8.60043L19.2872 7.74304L38.3761 8.60043L19.1881 30.9999L0 8.60043Z',
          fill: '#FFB04C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M38.3761 8.60008H0L6.12474 0H32.2514L38.3761 8.60008Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M32.2516 0.000183105V8.60026H38.3763L32.2516 0.000183105Z',
          fill: '#FFC866',
        },
      }),
      h('path', {
        attrs: {
          d: 'M32.2171 8.65885L19.188 30.9996L38.2087 8.79556C38.2744 8.71873 38.2199 8.60016 38.1187 8.60016L32.3193 8.60016C32.2772 8.60016 32.2383 8.62249 32.2171 8.65885Z',
          fill: '#F7A05E',
        },
      }),
      h('path', {
        attrs: {
          d: 'M6.12463 -6.10352e-05L32.2513 -6.10352e-05L19.188 30.9995L6.12463 -6.10352e-05Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M28.6272 8.60002L32.2513 -6.10352e-05L6.12463 -6.10352e-05L9.74871 8.60002L28.6272 8.60002Z',
          fill: '#FFF2BB',
        },
      }),
      h('path', {
        attrs: {
          d: 'M9.74878 8.60026L19.188 0.000183105L28.6273 8.60026L9.74878 8.60026Z',
          fill: '#FFEB8A',
        },
      }),
      h('path', {
        attrs: {
          d: 'M0 8.60043L19.2872 7.74304L38.3761 8.60043L19.1881 30.9999L0 8.60043Z',
          fill: '#FFB04C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M38.3761 8.60008H0L6.12474 0H32.2514L38.3761 8.60008Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M32.2516 0.000183105V8.60026H38.3763L32.2516 0.000183105Z',
          fill: '#FFC866',
        },
      }),
      h('path', {
        attrs: {
          d: 'M32.2171 8.65885L19.188 30.9996L38.2087 8.79556C38.2744 8.71873 38.2199 8.60016 38.1187 8.60016L32.3193 8.60016C32.2772 8.60016 32.2383 8.62249 32.2171 8.65885Z',
          fill: '#F7A05E',
        },
      }),
      h('path', {
        attrs: {
          d: 'M6.12463 -6.10352e-05L32.2513 -6.10352e-05L19.188 30.9995L6.12463 -6.10352e-05Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M28.6272 8.60002L32.2513 -6.10352e-05L6.12463 -6.10352e-05L9.74871 8.60002L28.6272 8.60002Z',
          fill: '#FFF2BB',
        },
      }),
      h('path', {
        attrs: {
          d: 'M9.74878 8.60026L19.188 0.000183105L28.6273 8.60026L9.74878 8.60026Z',
          fill: '#FFEB8A',
        },
      }),
    ])
  },
}

const LargeDiamondIcon = {
  render(h) {
    return h('svg', {
      attrs: {
        width: '95',
        height: '83',
        viewBox: '0 0 95 83',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
      },
    }, [
      h('g', {
        attrs: {
          filter: 'url(#filter0_d_48_11989)',
        },
      }, [
        h('path', {
          attrs: {
            d: 'M62.7842 27.6729L48.3965 58.6455L38.7979 52.2324L39.1025 62.457L24.7178 60.6582L24.1006 55.5059L32.3984 47.957L20 39.6738L24.1387 28.1699L53.2666 20L62.7842 27.6729ZM74.1113 51.2188L72.9014 57.4619L55.1611 58.3838L56.9736 40.7119L63.2686 39.8154L74.1113 51.2188Z',
            fill: '#FFEB8A',
          },
        }),
      ]),
      h('path', {
        attrs: {
          d: 'M40.697 31.6282L62.2473 26.6148L62.3869 26.5918C62.7143 26.5632 63.0394 26.6984 63.2504 26.9582C63.4912 27.2549 63.5421 27.6632 63.3811 28.0098L48.9935 58.9821C48.8705 59.2469 48.6376 59.445 48.3564 59.5239C48.0752 59.6028 47.7733 59.5547 47.5305 59.3925L19.1337 40.4212C18.8158 40.2088 18.6465 39.833 18.6982 39.4541C18.7499 39.0752 19.0142 38.7593 19.3775 38.6398L40.6114 31.6522L40.697 31.6282Z',
          fill: '#FFB04C',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M52.6859 18.9525L52.8034 18.9267C53.0795 18.884 53.3632 18.9592 53.5835 19.1369L63.1012 26.8095C63.3926 27.0444 63.5283 27.4223 63.453 27.789C63.3778 28.1556 63.1042 28.4497 62.7438 28.5508L19.9595 40.5518C19.5991 40.6529 19.2125 40.544 18.9575 40.27C18.7025 39.996 18.6219 39.6026 18.7486 39.2504L22.8874 27.7472L22.9345 27.6366C23.0599 27.3869 23.2856 27.1993 23.5582 27.1229L52.6859 18.9525Z',
          fill: '#FFDB6C',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M52.4057 19.0811C52.7688 18.8416 53.2451 18.8641 53.5837 19.137L63.1014 26.8097C63.3928 27.0446 63.5285 27.4225 63.4532 27.7891C63.3779 28.1558 63.1044 28.4499 62.7439 28.551L55.9157 30.4663C55.3839 30.6155 54.8319 30.3053 54.6828 29.7736L51.9933 20.1856L51.9623 20.028C51.9204 19.6586 52.088 19.2906 52.4057 19.0811Z',
          fill: '#FFC866',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M61.9168 26.7057C62.7943 26.4596 63.5611 27.2841 63.3177 28.113L63.2556 28.2785L63.2549 28.2797L48.9936 58.9823C48.7757 59.4514 48.2357 59.6765 47.7488 59.5018C47.2619 59.3271 46.9881 58.8101 47.1182 58.3095L54.658 29.328C54.7601 28.9352 55.0634 28.628 55.4515 28.5192L61.9168 26.7057Z',
          fill: '#F7A05E',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M52.6858 18.9525L52.8073 18.9265C53.0934 18.8835 53.3865 18.9667 53.6086 19.1582C53.8624 19.3769 53.9903 19.7082 53.9485 20.0406L49.0786 58.6855C49.0283 59.0846 48.7436 59.4154 48.3564 59.524C47.9691 59.6326 47.5539 59.4981 47.3034 59.1834L23.0455 28.7089C22.8368 28.4468 22.7738 28.0973 22.8768 27.7785C22.9798 27.4596 23.2354 27.2133 23.558 27.1229L52.6858 18.9525Z',
          fill: '#FFDB6C',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M52.6858 18.9525L52.8073 18.9265C53.0934 18.8835 53.3865 18.9667 53.6086 19.1582C53.8306 19.3495 53.9562 19.6268 53.956 19.9157L53.9485 20.0406L52.5975 30.7619C52.5472 31.1609 52.2623 31.4908 51.875 31.5995L30.828 37.5032C30.4408 37.6118 30.0258 37.4781 29.7753 37.1635L23.0455 28.7089C22.8368 28.4468 22.7738 28.0973 22.8768 27.7785C22.9798 27.4596 23.2354 27.2133 23.558 27.1229L52.6858 18.9525Z',
          fill: '#FFF2BB',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M37.5985 23.3917C37.8873 23.0146 38.4087 22.8898 38.8412 23.107L52.0541 29.7431C52.423 29.9285 52.6401 30.322 52.6006 30.7329C52.5609 31.1439 52.2726 31.4882 51.8751 31.5997L30.828 37.5034C30.4305 37.6149 30.0052 37.4708 29.7576 37.1404C29.5101 36.8099 29.4908 36.361 29.7095 36.0108L37.5436 23.471L37.5985 23.3917Z',
          fill: '#FFEB8A',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M19.6895 39.5894L40.924 32.6021L62.4738 27.5884L48.0864 58.5613L19.6895 39.5894Z',
          fill: '#FFB04C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M62.4737 27.588L19.6894 39.589L23.8283 28.0857L52.956 19.9154L62.4737 27.588Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M52.9562 19.9155L55.6456 29.5035L62.4739 27.5881L52.9562 19.9155Z',
          fill: '#FFC866',
        },
      }),
      h('path', {
        attrs: {
          d: 'M55.6257 29.5795L48.0863 58.561L62.3482 27.8582C62.3975 27.752 62.2996 27.6369 62.1868 27.6685L55.7212 29.4821C55.6743 29.4953 55.6379 29.5324 55.6257 29.5795Z',
          fill: '#F7A05E',
        },
      }),
      h('path', {
        attrs: {
          d: 'M23.8281 28.0857L52.9559 19.9153L48.0862 58.5609L23.8281 28.0857Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M51.6049 30.6366L52.9559 19.9153L23.8281 28.0857L30.5579 36.5403L51.6049 30.6366Z',
          fill: '#FFF2BB',
        },
      }),
      h('path', {
        attrs: {
          d: 'M30.558 36.5406L38.392 24.0008L51.605 30.6369L30.558 36.5406Z',
          fill: '#FFEB8A',
        },
      }),
      h('path', {
        attrs: {
          d: 'M30.3596 53.2398L23.7021 59.8649C23.4314 60.1345 23.3377 60.5344 23.461 60.896C23.5692 61.2126 23.8271 61.4517 24.144 61.5381L24.2838 61.5655L38.6676 63.3644C38.9574 63.4007 39.2488 63.3084 39.4649 63.1119C39.6808 62.9154 39.7997 62.6345 39.791 62.3427L39.3614 47.8526C39.35 47.4703 39.1214 47.1274 38.7728 46.9702C38.4241 46.813 38.0161 46.8695 37.7221 47.114L30.4253 53.18L30.3596 53.2398Z',
          fill: '#FFB04C',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M23.1177 54.681L23.0335 54.7669C22.8508 54.9783 22.7641 55.2586 22.7977 55.5397L23.4142 60.6922C23.4587 61.0639 23.7076 61.3801 24.0584 61.5108C24.409 61.6414 24.803 61.5648 25.0798 61.3131L39.0341 48.622C39.3109 48.3702 39.4243 47.9852 39.3275 47.6238C39.2305 47.2622 38.9393 46.9845 38.5735 46.905L33.5031 45.8033L33.3837 45.7852C33.1055 45.7591 32.8266 45.8509 32.6173 46.0413L23.1177 54.681Z',
          fill: '#FFDB6C',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M23.3752 54.5117C22.9796 54.6925 22.7459 55.1081 22.7976 55.5399L23.414 60.6924L23.4407 60.8292C23.5229 61.1403 23.7514 61.3967 24.0582 61.5111C24.4088 61.6417 24.8028 61.565 25.0797 61.3134L27.307 59.2877C27.7156 58.9161 27.7456 58.2836 27.374 57.875L24.5302 54.7482L24.413 54.6383C24.1222 54.4068 23.7214 54.3536 23.3752 54.5117Z',
          fill: '#FFC866',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M23.828 59.7481C23.1587 60.3569 23.5129 61.468 24.4083 61.5806L24.4089 61.5813L38.6677 63.3647C39.181 63.4289 39.6583 63.0906 39.7685 62.5852C39.8787 62.0798 39.5858 61.5734 39.0925 61.418L26.9666 57.6038C26.6062 57.4902 26.2143 57.5777 25.9369 57.8301L23.828 59.7481Z',
          fill: '#F7A05E',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M23.1172 54.6807C22.8695 54.9061 22.7511 55.241 22.8018 55.572C22.8527 55.9031 23.0663 56.1868 23.3702 56.3276L38.3719 63.2792C38.7367 63.4481 39.167 63.3823 39.4645 63.1118C39.762 62.8412 39.8689 62.4186 39.7351 62.0393L34.2338 46.4474C34.1223 46.1314 33.8595 45.8926 33.5346 45.8107C33.2097 45.7289 32.8653 45.8149 32.6175 46.0403L23.1172 54.6807Z',
          fill: '#FFDB6C',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M23.1172 54.6807L23.0307 54.7699C22.8426 54.9895 22.7574 55.2823 22.8018 55.572C22.8527 55.9031 23.0663 56.1868 23.3702 56.3276L27.5318 58.2559C27.8966 58.425 28.3268 58.359 28.6244 58.0886L35.4891 51.8452C35.7495 51.6084 35.8638 51.2556 35.7986 50.9169L35.7598 50.7726L34.2338 46.4474C34.1223 46.1314 33.8595 45.8926 33.5346 45.8107C33.2097 45.7289 32.8653 45.8149 32.6175 46.0403L23.1172 54.6807Z',
          fill: '#FFF2BB',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M28.4451 50.1049C27.9724 50.1498 27.5906 50.525 27.5451 51.0066L26.9565 57.2551L26.9534 57.4084C26.9742 57.7616 27.1823 58.0819 27.5055 58.2434C27.8748 58.4279 28.319 58.3667 28.6245 58.0891L35.4893 51.8456C35.7947 51.5678 35.8983 51.1309 35.7495 50.7457C35.6007 50.3606 35.2304 50.1059 34.8175 50.1056L28.5414 50.1005L28.4451 50.1049Z',
          fill: '#FFEB8A',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M38.3614 47.8823L31.0648 53.9488L24.4074 60.5733L38.7919 62.3725L38.3614 47.8823Z',
          fill: '#FFB04C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M24.4075 60.5735L38.3615 47.8825L33.2904 46.7808L23.7904 55.4209L24.4075 60.5735Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M23.7904 55.4211L26.6345 58.5482L24.4074 60.5736L23.7904 55.4211Z',
          fill: '#FFC866',
        },
      }),
      h('path', {
        attrs: {
          d: 'M26.6662 58.5574L38.7919 62.3721L24.5329 60.5886C24.4835 60.5824 24.4641 60.5212 24.5009 60.4878L26.6097 58.5699C26.625 58.556 26.6465 58.5512 26.6662 58.5574Z',
          fill: '#F7A05E',
        },
      }),
      h('path', {
        attrs: {
          d: 'M33.2903 46.7801L23.7903 55.4202L38.7919 62.372L33.2903 46.7801Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M27.9521 57.3488L23.7903 55.4202L33.2903 46.7801L34.8166 51.1057L27.9521 57.3488Z',
          fill: '#FFF2BB',
        },
      }),
      h('path', {
        attrs: {
          d: 'M34.8167 51.1062L28.5404 51.1006L27.9522 57.3493L34.8167 51.1062Z',
          fill: '#FFEB8A',
        },
      }),
      h('path', {
        attrs: {
          d: 'M65.7968 48.0337L73.3452 56.7212L73.4301 56.8345C73.6084 57.1105 73.6418 57.4604 73.5109 57.7684C73.38 58.0761 73.1055 58.2947 72.7832 58.358L72.6426 58.3758L54.9023 59.2981C54.6107 59.3132 54.3273 59.1994 54.1261 58.9878C53.9499 58.8026 53.8519 58.5583 53.8504 58.3053L53.8551 58.197L55.6679 40.5255C55.7069 40.1453 55.9594 39.8204 56.3182 39.6887C56.6773 39.5572 57.0808 39.6424 57.3564 39.9076L65.7356 47.9693L65.7968 48.0337Z',
          fill: '#FFB04C',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M74.5262 50.4454L74.6041 50.5372C74.7707 50.7612 74.8371 51.0472 74.7832 51.325L73.5714 57.5672C73.5001 57.9347 73.2296 58.2313 72.8703 58.3364C72.511 58.4413 72.1231 58.3371 71.8652 58.0659L55.9376 41.3166C55.6797 41.0454 55.5951 40.6527 55.718 40.2992C55.8409 39.9456 56.1508 39.6904 56.5214 39.6376L62.8166 38.7411L62.9371 38.7317C63.2162 38.7259 63.4872 38.8371 63.6822 39.0419L74.5262 50.4454Z',
          fill: '#FFDB6C',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M74.2817 50.257C74.6631 50.4659 74.8661 50.8974 74.7832 51.3244L73.5715 57.5666C73.5002 57.934 73.2302 58.2314 72.8711 58.3365C72.5118 58.4415 72.1232 58.3365 71.8652 58.0653L69.3235 55.3924C68.9429 54.9922 68.9588 54.3592 69.359 53.9786L73.1125 50.4093C73.4277 50.1096 73.9002 50.0482 74.2817 50.257Z',
          fill: '#FFC866',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M73.2078 56.5754C73.839 57.2391 73.4003 58.3355 72.4881 58.3836L72.4868 58.3836L54.9021 59.2981C54.3855 59.3249 53.934 58.9529 53.8606 58.4409C53.7873 57.9289 54.1162 57.445 54.6194 57.3258L69.7783 53.7399C70.1504 53.652 70.5397 53.7697 70.8013 54.0447L73.2078 56.5754Z',
          fill: '#F7A05E',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M74.5263 50.4455L74.6068 50.5414C74.7783 50.774 74.8415 51.0716 74.7762 51.3573C74.7016 51.684 74.4687 51.952 74.1552 52.0704L55.2039 59.2343C54.8278 59.3765 54.4028 59.2802 54.1256 58.9889C53.8484 58.6974 53.7731 58.2676 53.934 57.8989L62.0413 39.3316C62.1754 39.0246 62.4548 38.8054 62.7848 38.7473C63.1148 38.6892 63.452 38.7999 63.6829 39.0427L74.5263 50.4455Z',
          fill: '#FFDB6C',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M74.5263 50.4455L74.6068 50.5414C74.7783 50.774 74.8415 51.0716 74.7762 51.3573C74.7016 51.684 74.4687 51.952 74.1552 52.0704L68.8977 54.0582C68.5215 54.2003 68.0965 54.1028 67.8194 53.8114L59.9842 45.5719C59.7418 45.317 59.6533 44.9566 59.7427 44.6237L59.7919 44.4826L62.0413 39.3316C62.1754 39.0246 62.4548 38.8054 62.7848 38.7473C63.1148 38.6892 63.452 38.7999 63.6829 39.0427L74.5263 50.4455Z',
          fill: '#FFF2BB',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M68.5465 44.4462C69.0151 44.525 69.3691 44.9275 69.3795 45.4114L69.544 53.1009C69.5527 53.5136 69.3065 53.8895 68.9247 54.0468C68.543 54.204 68.1038 54.1103 67.8192 53.8111L59.984 45.5716C59.6995 45.2725 59.628 44.8291 59.8041 44.4557C59.9804 44.0824 60.3682 43.8554 60.78 43.8848L68.4515 44.4355L68.5465 44.4462Z',
          fill: '#FFEB8A',
          stroke: '#80451A',
          'stroke-width': '2',
          'stroke-linejoin': 'round',
        },
      }),
      h('path', {
        attrs: {
          d: 'M56.6629 40.6277L65.042 48.6897L72.5905 57.3769L54.8505 58.2989L56.6629 40.6277Z',
          fill: '#FFB04C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M72.5898 57.3768L56.6623 40.6275L62.9578 39.7313L73.8013 51.1343L72.5898 57.3768Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M73.8016 51.1339L70.0481 54.7033L72.5901 57.3764L73.8016 51.1339Z',
          fill: '#FFC866',
        },
      }),
      h('path', {
        attrs: {
          d: 'M70.0083 54.7133L54.8501 58.299L72.4354 57.385C72.4962 57.3818 72.5253 57.3088 72.4833 57.2647L70.0763 54.7335C70.0589 54.7152 70.033 54.7074 70.0083 54.7133Z',
          fill: '#F7A05E',
        },
      }),
      h('path', {
        attrs: {
          d: 'M62.9583 39.7318L73.8018 51.1348L54.8503 58.2993L62.9583 39.7318Z',
          fill: '#FFDB6C',
        },
      }),
      h('path', {
        attrs: {
          d: 'M68.5442 53.1224L73.8018 51.1348L62.9583 39.7318L60.7089 44.8829L68.5442 53.1224Z',
          fill: '#FFF2BB',
        },
      }),
      h('path', {
        attrs: {
          d: 'M60.7087 44.8825L68.3798 45.4329L68.544 53.122L60.7087 44.8825Z',
          fill: '#FFEB8A',
        },
      }),
      h('defs', {}, [
        h('filter', {
          attrs: {
            id: 'filter0_d_48_11989',
            x: '0.1',
            y: '0.1',
            width: '93.9113',
            height: '82.257',
            filterUnits: 'userSpaceOnUse',
            'color-interpolation-filters': 'sRGB',
          },
        }, [
          h('feFlood', {
            attrs: {
              'flood-opacity': '0',
              result: 'BackgroundImageFix',
            },
          }),
          h('feColorMatrix', {
            attrs: {
              in: 'SourceAlpha',
              type: 'matrix',
              values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
              result: 'hardAlpha',
            },
          }),
          h('feOffset'),
          h('feGaussianBlur', {
            attrs: {
              stdDeviation: '9.95',
            },
          }),
          h('feComposite', {
            attrs: {
              in2: 'hardAlpha',
              operator: 'out',
            },
          }),
          h('feColorMatrix', {
            attrs: {
              type: 'matrix',
              values: '0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.541176 0 0 0 0.42 0',
            },
          }),
          h('feBlend', {
            attrs: {
              mode: 'normal',
              in2: 'BackgroundImageFix',
              result: 'effect1_dropShadow_48_11989',
            },
          }),
          h('feBlend', {
            attrs: {
              mode: 'normal',
              in: 'SourceGraphic',
              in2: 'effect1_dropShadow_48_11989',
              result: 'shape',
            },
          }),
        ]),
      ]),
    ])
  },
}

export default {
  name: 'Paywall2',
  components: {
    DiamondIcon,
    LargeDiamondIcon,
  },
  props: {
    name: {
      type: String,
      default: 'p2',
    },
    product: {
      type: Object,
      default: null,
    },
    remaining_counter: {
      type: Number,
      default: 0,
    },
    video: {
      type: String,
      default: require('@/assets/videos/p2/video1.mp4'),
    },
  },
  data() {
    return {
      showTimer: false,
      timer: 3600, // 1 hour in seconds
      interval: null,
      showOriginalPrice: true,
    }
  },
  computed: {
    discountRate() {
      if (!this.product) return 0

      if (endsWithN(this.product.product_id)) {
        return 40
      }

      return 20
    },

    displayTime() {
      const hours = Math.floor(this.timer / 3600)
      const minutes = Math.floor((this.timer % 3600) / 60)
      const seconds = this.timer % 60

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },

    originalPrice() {
      if (!this.product || !this.product.amount) return ''

      let amount = 0

      if (this.userCountry !== 'TR') {
        amount = parseFloat(this.product.global_amount)
      } else {
        amount = parseFloat(this.product.amount)
      }

      // eslint-disable-next-line no-restricted-globals
      if (isNaN(amount)) return ''
      return (amount / (1 - (this.discountRate / 100))).toFixed(2)
    },

    userCountry() {
      return this.$store.getters['auth/userCountry']
    },
  },
  created() {
    if (this.remaining_counter) {
      this.showTimer = true
      this.timer = this.remaining_counter * 60

      this.startTimer()
    }
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    endsWithN,
    startTimer() {
      this.interval = setInterval(() => {
        if (this.timer > 0) {
          // eslint-disable-next-line no-plusplus
          this.timer--
        } else {
          this.clearTimer()
        }
      }, 1000)
    },

    clearTimer() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },

    handleClose() {
      this.$emit('close')
    },

    numberFormat,
  },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

.p2-container {
  position: fixed;
  max-width: 500px;
  width: 100%;
  margin: -92px auto 0 auto;
  padding: 0;
  height: 100vh !important;
  z-index: 99999;
  overflow: hidden;
  left: 50%;
  transform: translateX(-50%);

  .inner-container {
    position: relative;
    height: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.15) 0%,
            rgba(0, 0, 0, 0.3) 40%,
            rgba(0, 0, 0, 0.6) 70%
    );
    z-index: 0;
  }

  .video-background {
    position: absolute;
    left: -28px;
    top: 0;
    min-width: 118%;
    min-height: 70%;
    max-height: 80%;
    width: auto;
    height: auto;
    z-index: -1;
    object-fit: cover;
    overflow: hidden;
  }

  .close-button {
    position: absolute;
    right: 18px;
    top: 4px;
    color: white;
    font-size: 26px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 2;
  }

  .inner-container {
    position: relative;
    z-index: 1;
    max-width: 800px;
    padding: 20px 0 0 0;
  }

  .header-text {
    text-align: center;
    margin-bottom: 30px;
  }

  .timer {
    font-family: 'Inter', serif;
    background: linear-gradient(to right, #BB2AD1, #EE0658);
    color: white;
    display: inline-block;
    padding: 8px 20px;
    border-radius: 12px;
    font-weight: 800;
    font-size: 12px;
    margin-bottom: 16px;
  }

  .title {
    font-family: "Inter", serif;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 12px;
    max-width: 95%;
    text-align: center;
    color: #fff;
  }

  .diamond-container {
    text-align: center;
    margin-top: 20px;
  }

  .diamond-title {
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f4d575;
  }

  .product-title {
    font-weight: 600;
  }

  .promo-text {
    text-align: center;
    font-size: 12px;
    margin-bottom: 16px;
    padding: 0 15px;
    font-weight: 700;
    color: #fff;
  }

  .savings-text {
    font-size: 12px;
    font-weight: 600;
    padding: 16px;
    text-align: left;
    border-bottom: 1px solid #222222;
  }

  .price-box {
    background: linear-gradient(to right, #0A0B0D, #1E2023);
    padding: 4px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 12px 0 12px;
    border-radius: 14px;
  }

  .diamond-package {
    display: flex;
    align-items: center;
  }

  .diamond-amount {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
  }

  .price-display {
    background-color: #000;
    text-align: right;
    padding: 8px 16px;
    border-radius: 10px;
  }

  .original-price {
    text-decoration: line-through;
    color: #8F8F8F;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
  }

  .discounted-price {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
  }

  .buy-button {
    background: linear-gradient(to right, #ee0658, #bb2ad1);
    color: white;
    border: none;
    padding: 16px;
    border-radius: 14px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    width: 100%;
    box-shadow: 0 4px 15px rgba(203, 94, 238, 0.5);
  }

  .paywall-footer {
    background-color: #000;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
  }
}
</style>
